import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/FH_Logo-on-LG-Green.png';
import ImageSlideshow from '../components/ImageSlideshow';
import './Home.css';

const Home = () => {
  return (
    <div className="home">
      <ImageSlideshow />
      <div className="home-content">
        <img src={logo} alt="Forage Hill Cafe Logo" className="home-logo" />
        <h1>Welcome to Forage Hill</h1>
        <div className="home-buttons">
          <Link to="/menu" className="home-button">View Our Menu</Link>
          <Link to="/catering" className="home-button">Explore Our Catering</Link>
          <Link to="/gallery" className="home-button">Gallery</Link>
          <Link to="/contact" className="home-button">Contact Us</Link>
        </div>
      </div>
    </div>
  );
};

export default Home;
